/**
 * Extracts a user-facing error message from an axios/api error, falling back
 * to a safe default when no message is available. Shared by every challenge
 * card API function so error handling is uniform.
 */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object') return fallback
  const ax = err as { response?: { data?: unknown } }
  const data = ax.response?.data
  if (!data || typeof data !== 'object') return fallback
  const errorField = (data as { error?: unknown }).error
  if (typeof errorField === 'string' && errorField.trim()) return errorField
  return fallback
}
